import React, { useState, createContext } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.scss";
import { Allocations } from "./modules/Allocations";
import { Balances } from "./modules/Balances";
import { Default } from "./modules/Dashboard";
import { Holdings } from "./modules/Holdings";
import { Performance } from "./modules/Performance";
import { Transactions } from "./modules/Transactions";
import { DashBoard } from "./screens/dashBoard";
import { Login } from "./screens/login";
import { Rebalance } from "./modules/Rebalance"
import { TradesTransaction } from './modules/Trades'
import { TaskList, CreateTask } from './modules/Task'
import {ForgotPassword} from './modules/ForgotPassword/ForgotPassword'
import {ResetPassword} from './modules/ForgotPassword/ResetPassword'
import {ChangePassword} from './modules/ForgotPassword/ChangePassword'
import {UsersList} from './modules/Users'
import { QueryClientProvider, QueryClient } from "react-query";
import {Reports} from './modules/Reports/Reports_View'
import {ReportsDetails} from './modules/Reports/Reports_Details'
import Cookies from "js-cookie";
import {ClientSelection} from './modules/ClientSelection'


export const store = createContext();

function App() {
  const [token, setToken] = useState(null);
  const [userId, setUserId] = useState(null);
  const queryClient = new QueryClient ();

  const newtoken = Cookies.get('newJwt');




  console.log(Cookies.get("newJwt"))
  
  return (
    <div className="App theme-blue">
      <QueryClientProvider client={queryClient}>
      <store.Provider value={[token, setToken, userId, setUserId]}>
        <Routes>
          <Route path="/" element={<Login />}></Route>
          <Route path="/forgotpassword" element={<ForgotPassword />}></Route>
          <Route path="/resetpassword" element={<ResetPassword />}></Route>
          <Route path="selectclient" element={<ClientSelection />}></Route>
          <Route path="portal" element={<DashBoard />}>
            <Route path="default" element={<Default />}></Route>
            <Route path="holdings" element={<Holdings />}></Route>
            <Route path="transactions" element={<Transactions />}></Route>
            <Route path="balances" element={<Balances />}></Route>
            <Route path="performance" element={<Performance />}></Route>
            <Route path="allocations" element={<Allocations />}></Route>
            
            <Route path="trades" element={<TradesTransaction />}></Route>
            <Route path="rebalance" element={<Rebalance />}></Route>
            <Route path="task" element={<TaskList />}></Route>
            <Route path="createtask" element={<CreateTask />}></Route>
            <Route path="changePassword" element={<ChangePassword />}></Route>
            <Route path="users" element={<UsersList />}></Route>
            <Route path="reports" element={<Reports />}></Route>
            <Route path="reports/:reportId" element={<ReportsDetails />}></Route>
          </Route>
        </Routes>
      </store.Provider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
